import { LegalPage } from "../../components/LegalPage";

export function Baa() {
  return (
    <LegalPage
      title="Business Associate Agreement"
      description="WeConsult Rx Business Associate Agreement under HIPAA §164.504(e). Covers permitted uses, safeguards, subcontractors, breach notification, and termination."
      path="/baa"
      effective="2026-05-30"
    >
      <p>
        This summary describes our standard Business Associate Agreement
        (“BAA”), entered into with every Customer who is a Covered Entity (or
        Business Associate of one) under HIPAA, prior to any Protected Health
        Information being processed on the platform.
      </p>

      <h2>Why we sign a BAA</h2>
      <p>
        45 CFR §164.504(e) requires that Covered Entities obtain
        “satisfactory assurances” from their Business Associates that PHI will
        be appropriately safeguarded. The BAA is that assurance.
      </p>

      <h2>Permitted uses and disclosures</h2>
      <ul>
        <li>To provide the Services described in the MSA / Order Form.</li>
        <li>To perform proper management and administration of WeConsult Rx.</li>
        <li>To carry out our legal responsibilities.</li>
        <li>For data aggregation services (de-identified) as permitted by §164.504(e)(2)(i)(B).</li>
      </ul>

      <h2>Safeguards</h2>
      <p>
        We implement administrative, physical, and technical safeguards that
        reasonably and appropriately protect PHI as required by the Security
        Rule (§164.308 / .310 / .312). See our{" "}
        <a href="/hipaa">HIPAA controls page</a>.
      </p>

      <h2>Subcontractors</h2>
      <p>
        We will require any subcontractor that creates, receives, maintains, or
        transmits PHI on our behalf to sign a BAA with terms substantially
        equivalent to those in our BAA with Customer. See{" "}
        <a href="/subprocessors">/subprocessors</a>.
      </p>

      <h2>Breach notification</h2>
      <p>
        We will notify Customer of any Breach of unsecured PHI within the
        timeframes required by §164.410, and in no event later than sixty (60)
        calendar days from discovery.
      </p>

      <h2>Term and termination</h2>
      <p>
        The BAA terminates on termination of the underlying Service. Upon
        termination, we will return or destroy all PHI received, created, or
        maintained on behalf of Customer, where feasible.
      </p>

      <h2>Request a countersigned BAA</h2>
      <p>
        Email <strong>privacy@weconsultrx.com</strong> with the legal entity
        name and authorized signatory. We countersign within one business day.
      </p>
    </LegalPage>
  );
}
